<div class="flex flex-row gap-4">
  <div class="flex-1 flex flex-col gap-4">
    <div class="card shadow-sm">
      <div class="card-body p-3 gap-2">
        <div class="type-section-title">Timers</div>

        <div class="form-control">
          <label class="label cursor-pointer label-option">
            <span class="label-text">Tick Multiplier</span>
            <input
              #tickMultiplier
              type="range"
              [min]="1"
              [max]="100"
              [value]="getOption('debugTickMultiplier')"
              (change)="
                setOption('debugTickMultiplier', tickMultiplier.valueAsNumber)
              "
              class="range"
            />
            <span class="ml-2">{{ getOption('debugTickMultiplier') }}x</span>
          </label>
        </div>
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="card-body p-3 gap-2">
        <div class="type-section-title">Console Options</div>

        <div class="form-control">
          <label class="label cursor-pointer label-checkbox">
            <input
              type="checkbox"
              [checked]="getOption('debugConsoleLogStateUpdates') === true"
              class="checkbox"
              appAnalyticsClick="Options:Debug:LogStateUpdates"
              (click)="
                setOption(
                  'debugConsoleLogStateUpdates',
                  !getOption('debugConsoleLogStateUpdates')
                )
              "
            />
            <span class="label-text">Log state updates</span>
          </label>
        </div>

        <div class="form-control">
          <label class="label cursor-pointer label-checkbox">
            <input
              type="checkbox"
              [checked]="getOption('debugGameloopTimerUpdates') === true"
              class="checkbox"
              appAnalyticsClick="Options:Debug:LogTimerUpdates"
              (click)="
                setOption(
                  'debugGameloopTimerUpdates',
                  !getOption('debugGameloopTimerUpdates')
                )
              "
            />
            <span class="label-text">Log long (>100ms) gameloop timers</span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="flex-1 flex flex-col gap-4">
    <div class="card shadow-sm">
      <div class="card-body p-3 gap-2">
        <div class="type-section-title">Give Item / Equipment</div>

        <div class="debug-give-grid">
          <span class="label-text text-right">Item</span>
          <ng-select
            class="debug-give-select"
            [items]="debugItems()"
            bindLabel="name"
            bindValue="id"
            [clearable]="false"
            placeholder="Select an item..."
            [(ngModel)]="selectedItemId"
          ></ng-select>
          <input
            type="number"
            [min]="1"
            class="input input-bordered debug-give-qty"
            [(ngModel)]="itemQuantity"
          />
          <button
            type="button"
            class="btn btn-neutral debug-give-btn"
            appAnalyticsClick="Options:Debug:GiveItem"
            (click)="giveItem()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
          >
            Give
          </button>

          <span class="label-text text-right">Equipment</span>
          <ng-select
            class="debug-give-select"
            [items]="debugEquipment()"
            bindLabel="name"
            bindValue="id"
            [clearable]="false"
            placeholder="Select equipment..."
            [(ngModel)]="selectedEquipmentId"
          ></ng-select>
          <input
            type="number"
            [min]="1"
            class="input input-bordered debug-give-qty"
            [(ngModel)]="equipmentQuantity"
          />
          <button
            type="button"
            class="btn btn-neutral debug-give-btn"
            appAnalyticsClick="Options:Debug:GiveEquipment"
            (click)="giveEquipment()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
          >
            Give
          </button>

          <span class="label-text text-right">Collectible</span>
          <ng-select
            class="debug-give-select"
            [items]="debugCollectibles()"
            bindLabel="name"
            bindValue="id"
            [clearable]="false"
            placeholder="Select a collectible..."
            [(ngModel)]="selectedCollectibleId"
          ></ng-select>
          <input
            type="number"
            [min]="1"
            class="input input-bordered debug-give-qty"
            [(ngModel)]="collectibleQuantity"
          />
          <button
            type="button"
            class="btn btn-neutral debug-give-btn"
            appAnalyticsClick="Options:Debug:GiveCollectible"
            (click)="giveCollectible()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
          >
            Give
          </button>

          <span class="label-text text-right">Recipe</span>
          <ng-select
            class="debug-give-select"
            [items]="debugDropGatedRecipes()"
            bindLabel="name"
            bindValue="id"
            [clearable]="false"
            placeholder="Select a recipe..."
            [(ngModel)]="selectedRecipeId"
          ></ng-select>
          <span></span>
          <button
            type="button"
            class="btn btn-error btn-outline debug-give-btn"
            appAnalyticsClick="Options:Debug:UndiscoverRecipe"
            (click)="undiscoverRecipe()"
            appSfx="ui-error"
            [sfxTrigger]="['click', 'hover']"
          >
            Unlearn
          </button>
        </div>
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="card-body p-3 gap-2">
        <div class="type-section-title">Set Hero Level</div>

        <div class="debug-give-grid">
          <span class="label-text text-right">Hero</span>
          <ng-select
            class="debug-give-select"
            [items]="party()"
            bindLabel="name"
            bindValue="id"
            [clearable]="false"
            placeholder="Select a hero..."
            [(ngModel)]="selectedCharacterId"
          ></ng-select>
          <input
            type="number"
            [min]="1"
            [max]="characterMaxLevel"
            class="input input-bordered debug-give-qty"
            [(ngModel)]="characterLevel"
          />
          <button
            type="button"
            class="btn btn-neutral debug-give-btn"
            appAnalyticsClick="Options:Debug:SetCharacterLevel"
            (click)="setCharacterLevel()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
          >
            Set
          </button>
        </div>
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="card-body p-3 gap-2">
        <div class="type-section-title">Set Tradeskill Level</div>

        <div class="debug-give-grid">
          <span class="label-text text-right">Tradeskill</span>
          <ng-select
            class="debug-give-select"
            [items]="tradeskills"
            [clearable]="false"
            placeholder="Select a tradeskill..."
            [(ngModel)]="selectedTradeskill"
          ></ng-select>
          <input
            type="number"
            [min]="1"
            [max]="tradeskillMaxLevel"
            class="input input-bordered debug-give-qty"
            [(ngModel)]="tradeskillLevel"
          />
          <button
            type="button"
            class="btn btn-neutral debug-give-btn"
            appAnalyticsClick="Options:Debug:SetTradeskillLevel"
            (click)="setTradeskillLevel()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
          >
            Set
          </button>
        </div>
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="card-body p-3 gap-2">
        <div class="type-section-title">Workers</div>

        <div class="debug-give-grid">
          <span class="label-text text-right">Worker</span>
          <ng-select
            class="debug-give-select"
            [items]="debugWorkers()"
            bindLabel="name"
            bindValue="id"
            [clearable]="false"
            placeholder="Select a worker..."
            [(ngModel)]="selectedWorkerId"
          ></ng-select>

          <button
            type="button"
            class="btn btn-neutral debug-give-btn"
            appAnalyticsClick="Options:Debug:RescueWorker"
            (click)="rescueWorker()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
          >
            Rescue
          </button>

          <span></span>

          <span class="label-text text-right">Worker Level</span>

          <input
            type="number"
            [min]="1"
            [max]="workerMaxLevel"
            class="input input-bordered debug-give-qty"
            [(ngModel)]="workerLevel"
          />

          <button
            type="button"
            class="btn btn-neutral debug-give-btn"
            appAnalyticsClick="Options:Debug:SetWorkerLevel"
            (click)="setWorkerLevel()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
          >
            Set
          </button>
        </div>
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="card-body p-3 gap-2">
        <div class="type-section-title">Gather Nodes</div>

        <div class="debug-give-grid">
          <span class="label-text text-right">Gather Node</span>
          <ng-select
            class="debug-give-select"
            [items]="debugGatherNodes()"
            [clearable]="false"
            placeholder="Select a gather node..."
            [(ngModel)]="selectedGatherNodeName"
          ></ng-select>
          <span></span>
          <button
            type="button"
            class="btn btn-neutral debug-give-btn"
            appAnalyticsClick="Options:Debug:DiscoverGatherNode"
            (click)="discoverGatherNode()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
          >
            Discover
          </button>

          <span class="label-text text-right">Node Level</span>
          <input
            type="number"
            [min]="0"
            class="input input-bordered debug-give-qty"
            [(ngModel)]="gatherNodeLevel"
          />
          <button
            type="button"
            class="btn btn-neutral debug-give-btn"
            appAnalyticsClick="Options:Debug:SetGatherNodeLevel"
            (click)="setGatherNodeLevel()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
          >
            Set
          </button>
        </div>
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="card-body p-3 gap-2">
        <div class="type-section-title">Town Reputation</div>

        <div class="debug-give-grid">
          <span class="label-text text-right">Town</span>
          <ng-select
            class="debug-give-select"
            [items]="debugTowns()"
            bindLabel="name"
            bindValue="id"
            [clearable]="false"
            placeholder="Select a town..."
            [(ngModel)]="selectedTownId"
          ></ng-select>
          <span></span>
          <span></span>

          <span class="label-text text-right">Reputation</span>
          <input
            type="number"
            [min]="0"
            [max]="townReputationMax"
            class="input input-bordered debug-give-qty"
            [(ngModel)]="townReputationValue"
          />
          <button
            type="button"
            class="btn btn-neutral debug-give-btn"
            appAnalyticsClick="Options:Debug:SetTownReputation"
            (click)="setTownReputation()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
          >
            Set
          </button>

          <span></span>
          <span></span>

          <button
            type="button"
            class="btn btn-neutral debug-give-btn"
            appAnalyticsClick="Options:Debug:StartTownDefenseCombat"
            (click)="startTownDefenseCombat()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
          >
            Start Defense Combat
          </button>

          <span></span>
          <span></span>
          <span></span>
          <button
            type="button"
            class="btn btn-neutral debug-give-btn"
            appAnalyticsClick="Options:Debug:TelegraphRaid"
            (click)="telegraphRaid()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
          >
            Telegraph Raid
          </button>

          <span></span>
          <span></span>
          <span></span>
          <button
            type="button"
            class="btn btn-neutral debug-give-btn"
            appAnalyticsClick="Options:Debug:MarkTownVisited"
            (click)="markTownVisited()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
          >
            Mark Visited
          </button>
        </div>
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="card-body p-3 gap-2">
        <div class="type-section-title">Caravans</div>

        <div class="debug-give-grid">
          <span class="label-text text-right">Caravan</span>
          <ng-select
            class="debug-give-select"
            [items]="debugCaravans()"
            bindLabel="name"
            bindValue="id"
            [clearable]="false"
            placeholder="Select a caravan..."
            [(ngModel)]="selectedCaravanId"
          ></ng-select>
          <span></span>
          <button
            type="button"
            class="btn btn-neutral debug-give-btn"
            appAnalyticsClick="Options:Debug:MarkCaravanVisited"
            (click)="markCaravanVisited()"
            appSfx="ui-click"
            [sfxTrigger]="['click', 'hover']"
          >
            Mark Visited
          </button>
        </div>
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="card-body p-3 gap-2">
        <div class="type-section-title">Reset</div>

        <button
          type="button"
          class="btn btn-error btn-outline btn-sm"
          appAnalyticsClick="Options:Debug:ResetBestiary"
          (click)="resetBestiary()"
          appSfx="ui-error"
          [sfxTrigger]="['click', 'hover']"
        >
          Reset Bestiary
        </button>
        <button
          type="button"
          class="btn btn-error btn-outline btn-sm"
          appAnalyticsClick="Options:Debug:ResetHeroTeachings"
          (click)="resetHeroTeachings()"
          appSfx="ui-error"
          [sfxTrigger]="['click', 'hover']"
        >
          Reset Hero Teachings
        </button>
        <button
          type="button"
          class="btn btn-error btn-outline btn-sm"
          appAnalyticsClick="Options:Debug:ResetCommissions"
          (click)="resetCommissions()"
          appSfx="ui-error"
          [sfxTrigger]="['click', 'hover']"
        >
          Reset Commissions
        </button>
        <button
          type="button"
          class="btn btn-error btn-outline btn-sm"
          appAnalyticsClick="Options:Debug:ResetAllTutorials"
          (click)="resetAllTutorials()"
          appSfx="ui-error"
          [sfxTrigger]="['click', 'hover']"
        >
          Reset All Tutorials
        </button>
        <button
          type="button"
          class="btn btn-error btn-outline btn-sm"
          appAnalyticsClick="Options:Debug:ResetTasks"
          (click)="resetTasks()"
          appSfx="ui-error"
          [sfxTrigger]="['click', 'hover']"
        >
          Reset Tasks
        </button>
        <button
          type="button"
          class="btn btn-error btn-outline btn-sm"
          appAnalyticsClick="Options:Debug:ResetIntroCrawl"
          (click)="resetIntroCrawl()"
          appSfx="ui-error"
          [sfxTrigger]="['click', 'hover']"
        >
          Reset Intro Crawl
        </button>
        <button
          type="button"
          class="btn btn-error btn-outline btn-sm"
          appAnalyticsClick="Options:Debug:ResetOutroCrawl"
          (click)="resetOutroCrawl()"
          appSfx="ui-error"
          [sfxTrigger]="['click', 'hover']"
        >
          Reset Outro Crawl
        </button>
        <button
          type="button"
          class="btn btn-error btn-outline btn-sm"
          appAnalyticsClick="Options:Debug:ResetVictoryCard"
          (click)="resetVictoryCard()"
          appSfx="ui-error"
          [sfxTrigger]="['click', 'hover']"
        >
          Reset Victory Card
        </button>
        <button
          type="button"
          class="btn btn-neutral btn-sm"
          appAnalyticsClick="Options:Debug:FillBestiary"
          (click)="fillBestiary()"
          appSfx="ui-click"
          [sfxTrigger]="['click', 'hover']"
        >
          Fill Bestiary
        </button>
        <button
          type="button"
          class="btn btn-neutral btn-sm"
          appAnalyticsClick="Options:Debug:DiscoverAllRecipes"
          (click)="discoverAllRecipes()"
          appSfx="ui-click"
          [sfxTrigger]="['click', 'hover']"
        >
          Discover All Recipes
        </button>
      </div>
    </div>
  </div>
</div>
